<widget-card-guest-comment
  [comment]="comment"
  [survey]="survey"
  [productId]="1"
  [semanticInfo]="responseComment?.semantic_info"
  [isDateType]="isDateType"
  [guest]="guest"
  [satisfaction]="responseComment.answered_survey.satisfaction">
</widget-card-guest-comment>
